import { Button } from "antd";
import styled from "styled-components";

export const NotificationWrapper = styled.div<{ color?: string; borderColor?: string }>`
  border-radius: 5px;
  border: 1px solid ${(props) => props.borderColor};
  background: ${(props) => props.color};
  margin-bottom: 16px;
`;

export const NotificationBody = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const NotificationButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const NotificationMessage = styled.div`
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const NotificationButton = styled(Button)<{ color?: string; variant?: "primary" | "outline" }>`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 16px;
  border-radius: 5px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background: ${(props) => (props.variant === "primary" ? props.color : "#ffffff")};
  color: ${(props) => (props.variant === "primary" ? "#ffffff" : props.color)};
  border: ${(props) => (props.variant === "primary" ? `none` : `1px solid ${props.color}`)};
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);

  &:hover {
    border-color: ${(props) => (props.variant === "primary" ? `none` : props.color)} !important;
    background: ${(props) => (props.variant === "primary" ? props.color : "#ffffff")} !important;
    color: ${(props) => (props.variant === "primary" ? "#ffffff" : props.color)} !important;
  }

  &:hover span {
    color: ${(props) => (props.variant === "primary" ? "#ffffff" : props.color)} !important;
  }
`;
